import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { RktIconComponent } from '@rocketfinancialcorp/rocket-ui/icon';

@Component({
  selector: 'app-expandable-form-section',
  templateUrl: 'expandable-form-section.component.html',
  standalone: true,
  imports: [RktIconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExpandableFormSectionComponent {
  @Input() title?: string;

  @Input() titleIconName?: string;

  @Input() isExpanded = false;

  @Output() toggled = new EventEmitter();
}
